import React  from "react";
import { useParams } from 'react-router-dom';
import AccountForm from "./components/AccountForm";
import AccountTab from "./components/AccountTab";
import Card from "components/card";

const ViewAccount = () => {
	const { accountId } = useParams();
	return (
	    <div>
	    	<div className="mt-5 grid h-full grid-cols-1 gap-4">
	      		<AccountForm recordId={accountId} mode="view"/>
	      </div>

		  <div className="mt-4 mb-4">
			<Card extra={"w-full h-full p-4"}>
				<AccountTab recordId={accountId} />
			</Card>
				
	      </div>
	    </div>
    );
};

export default ViewAccount;